import { Component, OnInit, OnDestroy } from '@angular/core';
import { ToastService } from './services/toast.service';
import { PromptService } from './services/prompt.service';
import { Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { LoadingService } from './services/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  subscriptions: Subscription = new Subscription();
  toast = { html: '', hidden: true };
  prompt = {
    hidden: true,
    heading: '',
    body: '',
    confirmText: '',
    rejectText: '',
  };
  loading = false;
  loadingSubscription: Subscription;
  constructor(
    private toastService: ToastService,
    private promptService: PromptService,
    private loadingService: LoadingService,
    private router: Router
  ) {}

  ngOnInit() {

    this.router.events.subscribe((evt: any) => {
      if (!(evt instanceof NavigationEnd)) return;
      window.scrollTo(0, 0);
    });
    this.subscriptions.add(
      this.toastService.toast$.subscribe((t: any) => {
        if (t) {
          this.toast = { ...t };
        }
      })
    );
    this.subscriptions.add(
      this.promptService.prompt$.subscribe((p: any) => {
        if (p) {
          this.prompt = { ...p };
        }
      })
    );
    // Loading Subscription
    this.subscriptions.add(
      this.loadingService.loadingStatus.subscribe((l) => {
        this.loading = l;
      })
    );
  }

  onPromptResponse(response) {
    this.promptService.setResponse(response);
  }
}
